import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  root: css`
    display: flex;
    align-items: center;
    height: 40px;
  `,

  input: theme => css`
    width: 100%;
    height: 40px;
    padding-left: ${theme.spacing.xs};
    padding-right: ${theme.spacing.xs};
    border: 1px solid ${theme.colors.neutral[300]};
    border-top-left-radius: ${theme.border.radius.lg};
    border-bottom-left-radius: ${theme.border.radius.lg};
    outline: none;
    box-sizing: border-box;
  `,

  button: ({ spacing, border, colors }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.brand.primary[300]};
    margin: 0;
    min-width: ${spacing.lg};
    min-height: 40px;
    border: none;
    border-top-right-radius: ${border.radius.lg};
    border-bottom-right-radius: ${border.radius.lg};
    cursor: pointer;
    box-sizing: border-box;
    transition: 0.2s;

    &:hover {
      background-color: ${colors.brand.primary[400]};
    }
  `,
})

export { useStyles }
